
import React from "react";
import { RoomTypesSection } from "./RoomTypesSection";
import { AmenitiesSection } from "./AmenitiesSection";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ClaimingSection } from "./ClaimingSection";
import { SidebarCTA } from "./SidebarCTA";
import { ContactFormHandler } from "./ContactFormHandler";

interface NursingHomeSidebarProps {
  nursingHome: {
    center_name: string;
    nh_slug: string;
    county_slug: string;
    county_name?: string;
    room_types?: string[];
    amenities?: string[];
    claimed?: boolean;
    max_residents?: number;
    category?: string;
    email?: string;
    standardized_address?: string;
    hiqa_profile_url?: string;
  };
}

export function NursingHomeSidebar({ nursingHome }: NursingHomeSidebarProps) {
  return (
    <aside className="space-y-6" role="complementary">
      <div className="sticky top-4">
        {/* "Take the Next Step" CTA Section */}
        <SidebarCTA 
          centerName={nursingHome.center_name}
          nhSlug={nursingHome.nh_slug}
          countySlug={nursingHome.county_slug}
          hiqaProfileUrl={nursingHome.hiqa_profile_url}
          email={nursingHome.email}
        />
        
        {/* Contact Form */}
        <Card className="mb-6">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">Contact us about {nursingHome.center_name}</CardTitle>
          </CardHeader>
          <CardContent>
            <ContactFormHandler 
              nursingHomeName={nursingHome.center_name}
              nursingHomeId={nursingHome.nh_slug}
              county={nursingHome.county_name}
              email={nursingHome.email}
              submitLabel="Send Message"
              className="space-y-4"
            />
          </CardContent>
        </Card>

        {/* Claiming section */}
        <ClaimingSection 
          nhSlug={nursingHome.nh_slug}
          centerName={nursingHome.center_name}
          isClaimed={!!nursingHome.claimed}
        />
      </div>
    </aside>
  );
}
